module.exports = __webpack_public_path__ + "media/images/lb/013-d7332bd24d07a30a7aa02aecf05c8e80.svg";